import BaseLP from 'services/sports/default/base-lp';

export default class LpTiers extends BaseLP {
    subjectToPermanent() {
        const constraints = {
            tiers: this.exec('prepareSectionByTier', {}, ''),
            games: this.exec('prepareSectionByGame', {addPositionToPID: true}, ''),
            projectionBoostRule: this.exec(
                'projectionBoostRule',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            playersWhoseGamesAreLocked: this.exec(
                'playersWhoseGamesAreLocked',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            createdLineups: this.exec('prepareSectionByCreatedLineups_Tiers', {}, ''),
            multiPositions: this.exec('prepareSectionByMultiPositions', {}, ''),
            exposureMax: this.exec('prepareSectionByExposureMax', {}, ''),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            playerCombinationStacking: this.exec('playerCombinationStacking', {}, ''),
        };

        return {...constraints};
    }
}
